import { Box, Typography, styled } from "@mui/material"
import { getDefaultBgColor } from "./rankedBarTable.utils"

export const RANKED_BAR_TABLE_ROW_HEIGHT = 32

export const RankedBarTableRowCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== "rowBgColor",
})<{ rowBgColor?: string }>(({ theme, rowBgColor = getDefaultBgColor(theme) }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0.5, 1.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: rowBgColor,
  height: RANKED_BAR_TABLE_ROW_HEIGHT,
}))

export const RankedBarTableFillContainer = styled(RankedBarTableRowCard, {
  shouldForwardProp: (prop) => prop !== "showProgress",
})(({ theme }) => ({
  padding: `0 ${theme.spacing(1)} 0 0`,
  width: "calc(100% - 80px)",
}))

RankedBarTableFillContainer.defaultProps = {
  rowBgColor: "none",
}

export const RankedBarTableFill = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "progress" && prop !== "showProgress" && prop !== "barBgColor",
})<{ progress: number; showProgress: boolean; barBgColor?: string }>(
  ({
    theme,
    progress,
    showProgress,
    barBgColor = theme.palette.common.turquoise,
  }) => {
    const width = Math.round(progress) > 0 ? `${progress}%` : "1px"
    return {
      width: showProgress ? width : "100%",
      height: "100%",
      transition: "width 0.4s ease",
      borderRadius: theme.shape.borderRadius,
      background: showProgress ? barBgColor : "transparent",
      position: "relative",
    }
  },
)

/** Horizontal space reserved for the value displayed at the end of the progress bar */
export const RANKED_BAR_TABLE_VALUE_WIDTH = 90

export const RankedBarTableValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  whiteSpace: "nowrap",
  zIndex: 1,
  fontSize: theme.typography.pxToRem(16),
  maxWidth: `${RANKED_BAR_TABLE_VALUE_WIDTH}px`,
  display: "inline",
  position: "absolute",
  left: `calc(100% + ${theme.spacing(1)})`,
  top: "50%",
  transform: "translateY(-50%)",
}))

export const RankedBarTableRowLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "rowBgColor",
})<{ rowBgColor?: string }>(({ theme, rowBgColor = getDefaultBgColor(theme) }) => ({
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.getContrastText(rowBgColor),
}))
